import React from 'react';
import ContentModelHandler from '../../utils/ContentModelHandler';

interface ISideNavigationItems {
  sideNavigationItems: {
    title: string;
    sideNavigationRow: {
      // eslint-disable-next-line camelcase
      row_id: string;
      rowType: string;
      flexJustify: string;
      verticalAlignment: string;
      sideNavigationColumns: {
        id: string;
        mobileColumns: string;
        tabletColumns: string;
        desktopColumns: string;
        orderInDesktop: string;
        alignment: string;
        content: any;
      }[];
    };
  }[];
}

function SideNavigationItems({ sideNavigationItems }: ISideNavigationItems) {
  return (
    <div className='cl-side-nav-content'>
      {sideNavigationItems.map((sideNavigationItem, index: number) => (
        <div key={index}>
          {sideNavigationItem.title && <h2>{sideNavigationItem.title}</h2>}
          <div
            id={sideNavigationItem.sideNavigationRow.row_id}
            className={`${
              sideNavigationItem.sideNavigationRow.rowType === 'grid'
                ? 'cl-row'
                : 'cl-row cl-row--flex'
            } ${
              sideNavigationItem.sideNavigationRow.flexJustify
                ? `cl-row--justify-${sideNavigationItem.sideNavigationRow.flexJustify}`
                : ''
            } cl-row--align-${sideNavigationItem.sideNavigationRow.verticalAlignment}`}
          >
            {sideNavigationItem.sideNavigationRow?.sideNavigationColumns?.map((column) => (
              <div
                key={column.id}
                className={`cl-col col-span-${column.mobileColumns} md:col-span-${
                  column.tabletColumns
                } lg:col-span-${column.desktopColumns} ${
                  column.orderInDesktop ? `order-${column.orderInDesktop}` : ''
                } cl-col--${column.alignment}`}
              >
                {column.content.map((content: any) => {
                  return ContentModelHandler([content]);
                })}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default SideNavigationItems;
